import { mapGetters, mapActions } from 'vuex'
import LocalStorageService from '@/services/local-storage.service'
export default {
	methods: {
		...mapActions('settings', ['sendDwhAction']),
		timeClick() {
			const timestamp = Math.floor(Date.now() / 1000)
			return timestamp
		},

		sendTrigger({ category, action, module, title, data, content_chapter_id, time }) {
			if (this.dwhCredentials) {
				const triggerPayload = {
					session_id: this.sessionId,
					platform: 'web app',
					login: this.login,
					category,
					action,
					module,
					time,
				}

				if (this.version) {
					triggerPayload.version = this.version
				}

				if (content_chapter_id && content_chapter_id.length) {
					triggerPayload.chapter_id = content_chapter_id
				} else if (this.chapter_id) {
					triggerPayload.chapter_id = this.chapter_id
				}

				if (this.user_id) {
					triggerPayload.user_id = this.user_id
				}

				if (title) {
					triggerPayload.title = title
				}
				triggerPayload.time = this.timeClick()

				if (data) {
					triggerPayload.data = data
				}
				this.sendDwhAction({
					credentials: this.dwhCredentials,
					payload: triggerPayload,
				})
			}
		},
	},
	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('app', ['sessionId']),

		dwhCredentials() {
			return JSON.parse(LocalStorageService.get('settings')).dwh.value
		},
		user_id() {
			return this.profile ? this.profile.user_id : null
		},
		chapter_id() {
			return this.profile ? this.profile.chapters.map((chapter) => chapter.chapter_id) : null
		},
		version() {
			return process.env.VUE_APP_VERSION
		},
		login() {
			return LocalStorageService.get('email')
		},
	},
}
